import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

const addUrgencyApi = createAsyncThunk(
  'addUrgencyApi',
  async (body: any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = BILLING_ROUTES.URGENCY.add;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({
        status: 'error',
        msg: 'An unexpected error occurred while adding the urgency case.',
      });
    }
  }
);

export default addUrgencyApi;
